// extracted by mini-css-extract-plugin
export default {"file-sharing-content":"style_file-sharing-content__K5PT1","file-sharing-toggle":"style_file-sharing-toggle__e+Mac"};